import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useQuery, useMutation } from '@apollo/client';
import Papa from 'papaparse';


import Form from 'react-bootstrap/Form';
import Toast from 'react-bootstrap/Toast';
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

import ImageUpload from '../components/ImageUpload';

import {
  ADMIN_UPDATE_LINK_IMAGE,
  ADMIN_UPDATE_LINK_BANNER_IMAGE,
  ADMIN_UPDATE_LINK,
  ADMIN_DELETE_LINK,
  ADMIN_UPDATE_LINKS,
  ADMIN_UPDATE_CODES
} from "../utils/mutations";

import { QUERY_LINKS } from '../utils/queries';

import spinner from '../assets/spinner.gif';

function parseCsv(f) {
  return new Promise((resolve, reject) =>
    Papa.parse(f, {complete: resolve, error: reject})
  );
}

function AdminLinks() {
  const navigate = useNavigate();

  const [showLinksToast, setShowLinksToast] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [deletingLink, setDeletingLink] = useState(false);
  const [editingLink, setEditingLink] = useState({});
  const [formState, setFormState] = useState({});

  const { loading, error, data } = useQuery(QUERY_LINKS);

  const [updateLinks] =
    useMutation(ADMIN_UPDATE_LINKS, { refetchQueries: [QUERY_LINKS, 'getLinks'] });

  const [updateCodes] =
    useMutation(ADMIN_UPDATE_CODES, { refetchQueries: [QUERY_LINKS, 'getLinks'] });

  const [updateLink] =
    useMutation(ADMIN_UPDATE_LINK, { refetchQueries: [QUERY_LINKS, 'getLinks'] });

  const [deleteLink] =
    useMutation(ADMIN_DELETE_LINK, { refetchQueries: [QUERY_LINKS, 'getLinks'] });

  const [updateLinkImage] =
    useMutation(ADMIN_UPDATE_LINK_IMAGE);

  const [updateLinkBannerImage] =
    useMutation(ADMIN_UPDATE_LINK_BANNER_IMAGE);

  const [linksSelected, setLinksSelected] = useState(null);
  const [codesSelected, setCodesSelected] = useState(null);

  const urlOk = /^https:\/\/[\S]+$/;

  function disableSaveButton() {
    return (formState.name === editingLink.name &&
            formState.dealText === editingLink.dealText &&
            formState.rating === editingLink.rating &&
            formState.description === editingLink.description &&
            formState.url === editingLink.url &&
            formState.active === editingLink.active) || ! urlOk.test(formState.url);
  }

  function saveLink() {
    updateLink(
      {
        variables: {
          link: {
            _id: formState._id || undefined,
            name: formState.name,
            dealText: formState.dealText,
            rating: Number(formState.rating),
            description: formState.description,
            url: formState.url,
            active: formState.active
          }
        }
      })
      .then(({data: {adminUpdateLink}}) => navigate(`/affiliate/${adminUpdateLink}`))
  }

  function editModal(link) {
    setFormState(link);
    setEditingLink(link);
    setShowEdit(true);
  }

  function deleteModal(link) {
    console.log(link)
    setDeletingLink(link);
    setShowDelete(true);
  }

  function doDeleteLink() {
    deleteLink({ variables: { _id: deletingLink._id }})
      .then(() => {
        console.log('Deleted link')
        setShowDelete(false);
      });
  }

  function handleAffiliateLinksFile(e) {
    parseCsv(linksSelected)
      .then(({data}) => {
        if (data[0][2] === 'Image Filename') {
          delete data[0];
          const links = data.filter(r => r[0] || r[1])
            .map(r => ({
              name: r[0].trim(),
              description: r[1].trim(),
              url: r[3].trim(),
              active: Boolean(r[4])
            }));
          return updateLinks({ variables: {links} })
            .then(() => setShowLinksToast(true));
        } else {
          alert("You seem to have picked the wrong file.\n\nIt should have column headers ['Name', 'Description', 'Image Filename', 'URL', 'Active']");
        }
      });
  }

  function handleAliCodesFile(e) {
    parseCsv(codesSelected)
      .then(({data}) => {
        if (data[0][0] === "ProductId") {
          console.log(data)
          delete data[0];
          const codes = data.filter(r => r[0] || r[1])
            .map(r => ({
              productId: r[0],
              imageUrl: r[1],
              description: r[3],
              originalPrice: r[4],
              discountPrice: r[5],
              discount: r[6],
              currency: r[7],
              promotionUrl: r[14],
              codeName: r[15],
              codeStartTime: r[16],
              codeEndTime: r[17]
            }));
          return updateCodes({ variables: { codes } })
            .then(() => setShowLinksToast(true));
        } else {
          alert("You seem to have picked the wrong file.\n\nIt should have column headers ['ProductId',	'Image Url',	'Video Url',	'Product Desc' ...]");
        }
      });
  }

  function imageUploaded(_id, image) {
    updateLinkImage({ variables: { _id, image}})
      .then(() => console.log('Updated link image'));
  }

  function bannerImageUploaded(_id, image) {
    updateLinkBannerImage({ variables: { _id, image}})
      .then(() => console.log('Updated banner image'));
  }

  return (
    <div>
        <nav className="breadcrumb"><Link to="/admin">Admin</Link></nav>

        <h2>Admin Affiliate Links</h2>

        <section>
          {/*
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Update Affiliate Links from CSV</Form.Label>
              <Form.Control className="mb-2" type="file" accept=".csv,text/csv"
                onInput={e => setLinksSelected(e.nativeEvent.target.files[0])}></Form.Control>
              <button disabled={! linksSelected} type="button" className="btn btn-warning"
                onClick={handleAffiliateLinksFile}>Update Affiliate Links</button>
            </Form.Group>
          </Form>
          */}

          {
          <Form>
            <Form.Group className="mb-3">
              {/* <Form.Label>Add AliExpress Codes from XLS</Form.Label>
              <Form.Control className="mb-2" type="file" accept=".xls,application/vnd.ms-excel"
                onInput={e => setCodesSelected(e.nativeEvent.target.files[0])}></Form.Control> */}
              <Form.Label>Add AliExpress Codes from CSV</Form.Label>
              <Form.Control className="mb-2" type="file" accept=".csv,text/csv"
                onInput={e => setCodesSelected(e.nativeEvent.target.files[0])}></Form.Control>
              <button disabled={! codesSelected} type="button" className="btn btn-warning"
                onClick={handleAliCodesFile}>Add AliExpress Codes</button>
            </Form.Group>
          </Form>
          }

          <Toast onClose={() => setShowLinksToast(false)} show={showLinksToast} delay={15000} autohide>
            <Toast.Header>
              <img src="holder.js/20x20?text=%20" className="rounded me-2" alt="" />
              <strong className="me-auto">Notice</strong>
            </Toast.Header>
            <Toast.Body>Affiliate Link database has been updated from your file.</Toast.Body>
          </Toast>
        </section>

        <section>

          <div>
            <Button variant="outline-primary"
                    onClick={() => editModal({name:'', description:'', url:'', active:true})}>Add</Button>
          </div>

          {loading ? <img src={spinner} alt="loading" /> :
              (error ? <Alert variant="warning">{error}</Alert>
                : <table className="table">
                    <thead>
                      <tr>
                        <th scope="col">Name</th>
                        <th scope="col">Affiliate Url</th>
                        <th scope="col">Image</th>
                        <th scope="col">Banner Image</th>
                      </tr>
                    </thead>

                    { data && data.links.length ?
                      <tbody>
                        {
                          data.links.map(link =>
                            <tr key={link._id}>
                              <td>
                                <Link to={`/affiliate/${link._id}`}>
                                  {link.name || link.description}
                                </Link>
                                {link.dealText ? <div><div className="deal">{link.dealText}</div></div> : null}
                                {link.rating ? <p>Rating: {link.rating}</p> : null}
                                <div>
                                  <Button variant="outline-primary" onClick={() => editModal(link)}>Edit</Button>
                                  <Button variant="outline-warning" onClick={() => deleteModal(link)}>Delete</Button>
                                </div>
                              </td>
                              <td><a href={link.url}>{link.url}</a></td>
                              <td>
                                <ImageUpload small={true} initialImageId={link.image}
                                  onSuccess={id => imageUploaded(link._id, id)} />
                              </td>
                              <td>
                                <ImageUpload small={true} initialImageId={link.bannerImage}
                                  onSuccess={id => bannerImageUploaded(link._id, id)} />
                              </td>
                            </tr>)
                        }
                      </tbody> : null}
                  </table>
              )}
        </section>

                  <Modal size="lg" show={showEdit} onHide={() => setShowEdit(false)}>
                    <Modal.Dialog>
                      <Modal.Header closeButton>
                        <Modal.Title>{ formState._id ? 'Edit' : 'Add'} Affiliate Product</Modal.Title>
                      </Modal.Header>

                      <Modal.Body>

                        <Form.Group className="mb-3">
                          <Form.Label>Name:</Form.Label>
                          <Form.Control type="text" name="name" value={formState.name}
                            onChange={e => setFormState({...formState, name: e.target.value})} />
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label>Description:</Form.Label>
                          <Form.Control as="textarea" name="description" rows="20" value={formState.description}
                            onChange={e => setFormState({...formState, description: e.target.value})} />
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label>Affiliate link:</Form.Label>
                          <Form.Control type="text" name="url" value={formState.url}
                            onChange={e => setFormState({...formState, url: e.target.value})} />
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label>Deal text:</Form.Label>
                          <Form.Control type="text" name="dealText" value={formState.dealText}
                            onChange={e => setFormState({...formState, dealText: e.target.value})} />
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label>Rating:</Form.Label>
                          <Form.Control type="number" name="rating" value={formState.rating}
                            onChange={e => setFormState({...formState, rating: e.target.value})} />
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label>Visible on site:</Form.Label>
                          <Form.Check
                              type="checkbox"
                              label="Active"
                              value={true}
                              checked={formState.active}
                              onChange={e => setFormState({...formState, active: e.target.checked})}
                            />
                        </Form.Group>

                      </Modal.Body>

                      <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowEdit(false)}>Cancel</Button>
                        <Button variant="primary" disabled={disableSaveButton()} onClick={saveLink}>
                          {formState._id ? 'Save' : 'Update'} and View Page
                        </Button>
                      </Modal.Footer>
                    </Modal.Dialog>
                  </Modal>

                  <Modal size="lg" show={showDelete} onHide={() => setShowDelete(false)}>
                    <Modal.Dialog>
                      <Modal.Header closeButton>
                        <Modal.Title>Delete Affiliate Product</Modal.Title>
                      </Modal.Header>

                      <Modal.Body>
                        <p>Are you sure you want to delete {deletingLink.name}?</p>
                      </Modal.Body>

                      <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowDelete(false)}>Cancel</Button>
                        <Button variant="primary" onClick={doDeleteLink}>
                          Delete
                        </Button>
                      </Modal.Footer>
                    </Modal.Dialog>
                  </Modal>

    </div>
  );
}

export default AdminLinks;
